import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'kp-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent {
  @Input() isChecked: boolean;
  @Input() reversed = false;
  @Input() semanticLabel: string;
  @Output() check = new EventEmitter<boolean>();
  @ViewChild('checkboxInput', { static: false }) checkbox: ElementRef;

  checkboxChanged(inputChecked: boolean) {
    this.check.emit(inputChecked);
  }
}
